const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20golden%20sunset%20mountain%20landscape%2C%20epic%20adventure%20vibe%2C%20warm%20color%20palette%2C%20film%20texture%20overlay%2C%20movie%20poster%20quality%2C%20grand%20cinematic%20composition&width=700&height=420&seq=media-bajie-01&orientation=landscape',
    title: '史诗冒险巨制特辑',
    duration: '合集·12部',
    tag: '动作冒险',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20scene%20with%20soft%20warm%20evening%20light%2C%20emotional%20couple%20silhouette%2C%20beautiful%20sunset%20sky%2C%20dreamy%20bokeh%20effect%2C%20cinematic%20quality%2C%20elegant%20tender%20atmosphere&width=700&height=420&seq=media-bajie-02&orientation=landscape',
    title: '治愈系爱情电影精选',
    duration: '合集·18部',
    tag: '爱情浪漫',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20with%20neon%20lights%20and%20floating%20structures%2C%20cyberpunk%20aesthetic%2C%20warm%20accent%20lighting%2C%20cinematic%20composition%2C%20atmospheric%20and%20immersive%2C%20detailed%20world%20building&width=700&height=420&seq=media-bajie-03&orientation=landscape',
    title: '科幻迷必看系列合集',
    duration: '合集·25部',
    tag: '科幻奇幻',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20film%20aesthetic%20with%20bamboo%20forest%20and%20mist%2C%20elegant%20movement%2C%20warm%20golden%20light%2C%20traditional%20Chinese%20cinema%20style%2C%20atmospheric%20composition%2C%20poetic%20visual&width=700&height=420&seq=media-bajie-04&orientation=landscape',
    title: '经典武侠电影回顾',
    duration: '合集·30部',
    tag: '武侠经典',
  },
];

export default function Media() {
  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.style.display = 'none';
  };

  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按主题整理的影视合集，一次看过瘾</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((m, i) => (
            <div
              key={i}
              className="group rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden hover:-translate-y-1 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden bg-background-200">
                <img
                  src={m.img}
                  alt={m.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="700"
                  height="420"
                  onError={handleImgError}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-3 left-3 px-2 py-0.5 rounded text-xs font-medium bg-background-50/90 text-foreground-700 whitespace-nowrap">
                  {m.tag}
                </div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-1 text-background-50">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/25 flex-shrink-0">
                    <i className="ri-play-fill text-sm"></i>
                  </div>
                  <span className="text-xs font-medium whitespace-nowrap">{m.duration}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-800">{m.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}